var a = /* @__PURE__ */ ((r) => (r.FALight = "fal", r.FABrand = "fab", r))(a || {});
const l = ["fal", "fab"];
var t = /* @__PURE__ */ ((r) => (r.Xs = "xs", r.Sm = "sm", r.Lg = "lg", r.TwoTimes = "2x", r.ThreeTimes = "3x", r.FiveTimes = "5x", r.SevenTimes = "7x", r.TenTimes = "10x", r))(t || {});
const T = [
  "xs",
  "sm",
  "lg",
  "2x",
  "3x",
  "5x",
  "7x",
  "10x"
];
var s = /* @__PURE__ */ ((r) => (r.Horizontal = "horizontal", r.Vertical = "vertical", r.Both = "both", r))(s || {});
const h = ["horizontal", "vertical", "both"];
var e = /* @__PURE__ */ ((r) => (r.Deg90 = "90", r.Deg180 = "180", r.Deg270 = "270", r))(e || {});
const v = ["90", "180", "270"];
var x = /* @__PURE__ */ ((r) => (r.SpinHalf = "half", r.Spin1 = "1", r.Spin2 = "2", r.Spin3 = "3", r))(x || {});
const m = ["half", "1", "2", "3"];
export {
  h as ICON_FLIPS,
  v as ICON_ROTATES,
  l as ICON_SETS,
  T as ICON_SIZES,
  m as ICON_SPINS,
  s as IconFlip,
  e as IconRotate,
  a as IconSet,
  t as IconSize,
  x as IconSpin
};
